import { useMemo, useCallback } from 'react';
import { Dimensions, StyleSheet } from 'react-native';
import { TabView, TabViewProps } from 'react-native-tab-view';

import { spacing } from '../../../theme';
import { TabsContainerProps } from './TabsContainerProps';
import { TabBar } from '../TabBar/TabBar.web';

export const TabsContainer = ({
	currentIndex,
	onIndexChange,
	tabs,
	lazy,
	style,
}: TabsContainerProps) => {
	const tabRoutes = useMemo(
		() => tabs.map(({ name, label, badgeValue }) => ({ key: name, title: label, badgeValue })),
		[tabs],
	);

	const getTabScreen: TabViewProps<(typeof tabRoutes)[number]>['renderScene'] = useCallback(
		({ route }) => {
			return tabs.find(({ name }) => route.key === name)?.component;
		},
		[tabs],
	);

	return (
		<TabView
			style={[styles.tabView, style]}
			navigationState={{ index: currentIndex, routes: tabRoutes }}
			onIndexChange={onIndexChange}
			renderScene={getTabScreen}
			renderTabBar={TabBar}
			lazy={lazy}
			commonOptions={{
				sceneStyle: styles.scene,
			}}
			initialLayout={{ width: Dimensions.get('window').width - spacing(4) }}
		/>
	);
};

const styles = StyleSheet.create({
	tabView: {
		marginTop: spacing(4),
	},
	scene: {
		paddingVertical: spacing(2),
	},
});
